export const APP_NAME = "Capital One Travel";
export const SUBTITLE = "Open in the Capital One Travel app";
export const OPEN_CTA = "Open";
